import ApplicantDetails from './ApplicantDetails';

export default ApplicantDetails;
